import React from "react";

const money = (v) => (v < 0 ? `(${Math.abs(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })})`
                             : v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
const fmt = (item) => (item.type === "money" ? `$${money(Number(item.value || 0))}` : Number(item.value || 0).toLocaleString());

// Reusable across every report family. Driven by the envelope's summary block.
export default function ReportSummaryStrip({ summary = [] }) {
   return (
      <div className="d-flex gap-4 py-3 px-1 border-bottom" style={{ fontSize: 14 }}>
         {summary.map((item) => {
            const negative = item.type === "money" && Number(item.value) < 0;
            return (
               <div key={item.key} className="d-flex flex-column">
                  <span style={{ fontSize: 13, fontWeight: 400, color: "#6c757d" }}>{item.label}</span>
                  <span style={{ fontSize: 20, fontWeight: 600, color: negative ? "#dc3545" : "#000",
                                 fontVariantNumeric: "tabular-nums" }}>{fmt(item)}</span>
               </div>
            );
         })}
      </div>
   );
}
